/* Wishlist - localStorage based */
(function(){
var KEY='wishlist_items';
var Wishlist={
get:function(){try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(e){return [];}},
set:function(list){localStorage.setItem(KEY,JSON.stringify(list));window.dispatchEvent(new CustomEvent('wishlist:change',{detail:list}));},
has:function(handle){return this.get().indexOf(handle)!==-1;},
toggle:function(handle){var list=this.get();var i=list.indexOf(handle);if(i===-1){list.push(handle);}else{list.splice(i,1);}this.set(list);return this.has(handle);},
remove:function(handle){this.set(this.get().filter(function(h){return h!==handle;}));}
};
window.Wishlist=Wishlist;
function refreshButtons(){
document.querySelectorAll('.wishlist-btn').forEach(function(btn){
var h=btn.dataset.handle;
btn.classList.toggle('is-active',Wishlist.has(h));
btn.setAttribute('aria-pressed',Wishlist.has(h));
});
}
document.addEventListener('click',function(e){
    var btn=e.target.closest('.wishlist-btn');
    if(!btn)return;
    e.preventDefault();
    e.stopPropagation();
    var handle=btn.dataset.handle;
    if(!handle)return;
    Wishlist.toggle(handle);
    refreshButtons();
    });
    window.addEventListener('wishlist:change',refreshButtons);
    document.addEventListener('DOMContentLoaded',refreshButtons);
    function renderAccountWishlist(){
    var root=document.getElementById('wishlist-account');
    if(!root)return;
    var handles=Wishlist.get();
    if(handles.length===0){root.innerHTML='<p class="wishlist-empty">您的心愿单是空的。去 <a href="/collections/all">商店</a> 看看吧!</p>';return;}
    root.innerHTML='<p>加载中...</p>';
    Promise.all(handles.map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});})).then(function(items){
    var html=items.filter(Boolean).map(function(p){
    return '<div class="wishlist-item" data-handle="'+p.handle+'"><a href="/products/'+p.handle+'" class="wishlist-item__img"><img src="'+(p.featured_image||'')+'" alt="'+p.title+'" loading="lazy"></a><div class="wishlist-item__info"><a href="/products/'+p.handle+'" class="wishlist-item__title">'+p.title+'</a><div class="wishlist-item__price">'+(p.price/100).toFixed(2)+' '+(window.Shopify?Shopify.currency.active:'')+'</div><button type="button" class="wishlist-remove" data-handle="'+p.handle+'">移除</button></div></div>';
    }).join('');
    root.innerHTML='<div class="wishlist-grid">'+html+'</div>';
    root.querySelectorAll('.wishlist-remove').forEach(function(b){
    b.addEventListener('click',function(){Wishlist.remove(b.dataset.handle);renderAccountWishlist();});
    });
    });
    }
    document.addEventListener('DOMContentLoaded',renderAccountWishlist);
    window.addEventListener('wishlist:change',renderAccountWishlist);
    })();

